import { BillPayApp } from "@capitalos/react";
import { createFileRoute } from "@tanstack/react-router";
export const Route = createFileRoute("/_authed/_org/bill-pay")({
  component: RouteComponent,
});

function RouteComponent() {
  return (
    <div>
      <BillPayApp />
    </div>
  );
}
